import { useTranslation } from "react-i18next";
import * as Yup from "yup";

export const YupOrder = () => {
  //page hook
  const { t } = useTranslation();
  return {
    providerName: Yup.string().required(
      t("validation.required", {
        providerName: t("page.provider_name"),
      })
    ),
    township: Yup.string().required(
      t("validation.required", {
        township: t("page.township"),
      })
    ),
    phoneNumber: Yup.string().required(
      t("validation.required", {
        phoneNumber: t("page.phone_number"),
      })
    ),
    deliveryAddress: Yup.string().required(
      t("validation.required", {
        deliveryAddress: t("page.delivery_address"),
      })
    ),
  };
};
